import { Customer } from '@squareup/sq-addons-web-sdk';

import {
  CLEAR_SEARCH_CUSTOMERS,
  SEARCH_CUSTOMERS,
  SEARCH_CUSTOMERS_FULFILLED,
  SEARCH_CUSTOMERS_REJECTED,
  SearchCustomersAction,
  SearchCustomersFulfilledAction,
  SearchCustomersRejectedAction,
  ClearSearchCustomersAction,
} from './types';

export function searchCustomers(value: string): SearchCustomersAction {
  return {
    type: SEARCH_CUSTOMERS,
    payload: value,
  };
}

export function searchCustomersFulfilled(
  customers: Customer[]
): SearchCustomersFulfilledAction {
  return {
    type: SEARCH_CUSTOMERS_FULFILLED,
    payload: {
      searchResults: customers,
    },
  };
}

export function searchCustomersRejected(error: {
  apiError?: Error;
  validationError?: Error;
}): SearchCustomersRejectedAction {
  return {
    type: SEARCH_CUSTOMERS_REJECTED,
    payload: error,
  };
}

export function clearCustomersSearch(): ClearSearchCustomersAction {
  return {
    type: CLEAR_SEARCH_CUSTOMERS,
  };
}
